import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL ?? '';

// Le bouton Steam navigue vers le backend (qui redirige vers Steam, ou vers la démo).
export const steamLoginUrl = () => `${API_BASE_URL}/auth/steam/login`;

export const getVerdict = (steamId, locale) =>
  axios.get(`${API_BASE_URL}/scan/${encodeURIComponent(steamId)}`, { params: { locale } });

// Résout un lien de profil / pseudo d'URL / ID brut en SteamID64 -> scan sans connexion Steam.
export const resolveSteamId = (input) =>
  axios.get(`${API_BASE_URL}/steam/resolve`, { params: { input } });

export const subscribeEmail = (payload) =>
  axios.post(`${API_BASE_URL}/users/email`, payload);
